export {getDefaultAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-attachment.library';
import {aiPromptBoxActions} from '@Components/ai-prompt-box/ai-prompt-box.reducer';
import type {AiPromptBox} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {nextPromptBoxKey} from '@Components/ai-prompt-box/libraries/ai-prompt-box-key.library';

export function sendPrompt(promptBoxId: string, text: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: promptBoxId,
      value: {prompt: text, ...getFocusForSentPrompt(), submitKey: nextPromptBoxKey()},
    })
  );
}

/** On touch devices focusing the box raises the on-screen keyboard over the reply, so a prompt sent for the user leaves it unfocused there. */
function getFocusForSentPrompt(): Partial<Pick<AiPromptBox, 'promptBoxState' | 'focusKey'>> {
  if (window.PMW.isMobileOS()) {
    return {};
  }

  return {promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey()};
}

export function focusPromptBox(promptBoxId: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: promptBoxId,
      value: {promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey()},
    })
  );
}
